import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRole } from '../../lib/roles'
import Icon from '../AppIcon'
import { getBottomNavItems } from '../../lib/navigation'
import MobileMenuDrawer from './MobileMenuDrawer'

export function BottomNavigationView({ role, attendanceEmployee = false, onOpenMenu }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)
  const items = getBottomNavItems(role, { attendanceEmployee })
  const more = items.length > 5
  const visibleItems = more
    ? ['/home', '/timesheet', '/artgold-admin', '/jobs-management'].map(path => items.find(item => item.path === path)).filter(Boolean)
    : items
  if (location.pathname === '/login' || !items.length) return null
  return <><nav aria-label="Mobile navigation" className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-card pb-[env(safe-area-inset-bottom)] lg:hidden">
    <div className="mx-auto flex max-w-lg items-center justify-around px-2 py-2">
      {visibleItems.map(item => {
        const active = location.pathname === item.path || location.pathname.startsWith(item.path + '/')
        return <button type="button" key={item.path} onClick={() => navigate(item.path)} aria-current={active ? 'page' : undefined}
          className={'relative flex min-h-[48px] min-w-[56px] flex-1 flex-col items-center justify-center gap-1 rounded-lg px-1 text-foreground transition-colors ' + (active ? 'font-semibold' : 'hover:bg-muted')}>
          <Icon name={item.icon} size={20} className={active ? 'stroke-[2.2]' : 'stroke-[1.6]'} />
          <span className="text-[9px] font-medium whitespace-nowrap">{item.label}</span>
          {active && <span aria-hidden="true" className="absolute -top-2 h-0.5 w-5 rounded-full bg-foreground" />}
        </button>
      })}
      {more && <button type="button" onClick={onOpenMenu || (() => setMenuOpen(true))} aria-label="More navigation" className="flex min-h-[48px] min-w-[56px] flex-1 flex-col items-center justify-center gap-1 rounded-lg px-1 text-foreground hover:bg-muted"><Icon name="Menu" size={20} /><span className="text-[9px] font-medium">More</span></button>}
    </div>
  </nav>{!onOpenMenu && <MobileMenuDrawer isOpen={menuOpen} onClose={() => setMenuOpen(false)} items={items} />}</>
}

export default function BottomNavigation({ overrideRole = null }) {
  const { role, attendanceEmployee } = useRole()
  return <BottomNavigationView role={overrideRole || role} attendanceEmployee={attendanceEmployee} />
}
